// 只重置实际承载表格的滚动容器，保留横向位置，不滚动整扇窗口或弹窗外的页面。
function resetTablePageScroll(table) {
  if (!table || !table.ownerDocument) return;
  const view = table.ownerDocument.defaultView;
  for (let parent = table.parentElement; parent; parent = parent.parentElement) {
    const overflow = view.getComputedStyle(parent).overflowY;
    if (!/^(auto|scroll|overlay)$/.test(overflow) || parent.scrollHeight <= parent.clientHeight) continue;
    const top = table.getBoundingClientRect().top - parent.getBoundingClientRect().top - parent.clientTop;
    // 已在视口内的表格不额外向下滚动；翻页前位于列表底部才需要回到表头。
    if (top < 0) parent.scrollTop = Math.max(0, parent.scrollTop + top);
    return;
  }
}

module.exports = { resetTablePageScroll };
